import { createSelector } from 'reselect';
import { RootState } from 'store/rootReducer';

export const selectOnboardingProcessState = (state: RootState) => state.onboardingProcess;

export const selectOnboardingProcessStatusChecked = createSelector(
  selectOnboardingProcessState,
  (process) => process.isOnbordingStatusChecked,
);
